import * as React from 'react';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import { isEmpty } from 'lodash';
import messages from './messages';
import { KbArticle, Container, Root } from './styled';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { TRACK_EVENT_TYPE } from '@atlassian/analytics-web-react';
import type { KnowledgeArticle } from 'state/ui/search';
import { FieldBase } from '../field-base';

interface KbSuggestionFieldProps {
    articles: KnowledgeArticle[];
    connectedToForm?: boolean;
    portalId?: number;
}

export const KbSuggestionField: React.FunctionComponent<
    KbSuggestionFieldProps & InjectedIntlProps & WithAnalyticsEventsProps
> = ({ createAnalyticsEvent, articles, intl, connectedToForm, portalId }) => {
    React.useEffect(() => {
        createAnalyticsEvent &&
            createAnalyticsEvent({
                action: 'viewed',
                analyticsType: TRACK_EVENT_TYPE,
                actionSubjectId: `kbSuggestion${connectedToForm ? '-proforma' : ''}`,
                actionSubject: `kbSuggestionField${connectedToForm ? '-proforma' : ''}`,
            }).fire();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createAnalyticsEvent]);
    return (
        <Root>
            <FieldBase htmlFor="kb-suggest-article" label={intl.formatMessage(messages.label)}>
                {!isEmpty(articles) && (
                    <Container>
                        {articles.map((article) => (
                            <KbArticle
                                key={article.id}
                                elevated={false}
                                title={article.name}
                                openNewTab
                                focusable
                                isSuggestion
                                portalId={typeof portalId === 'number' ? portalId.toString() : portalId}
                                {...article}
                            />
                        ))}
                    </Container>
                )}
            </FieldBase>
        </Root>
    );
};

export default withAnalyticsEvents()(injectIntl(KbSuggestionField));
